module.exports = __webpack_public_path__ + "img/cards.7c4708e1.png";